var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1255,
    height: 445,
    viewBox: "0 0 1255 445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.7 333.293V347.491H240.867V425.335H400.693V420.678H557.566H610.5V336.393L237.7 333.293Z",
    fill: "#E8DFD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.603 365.455H274.133V410.698H372.603V365.455Z",
    fill: "#E8DFD4",
    stroke: "#845B24",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M566.88 348.156H392.563V420.012H566.88V348.156Z",
    fill: "#BFB8AF",
    stroke: "#845B24",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M323.834 377.67L318.977 386.08H328.691L323.834 377.67L318.977 386.08H328.691L323.834 377.67Z",
    fill: "#FFCE09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M323.834 377.67L318.977 386.08H328.691L323.834 377.67ZM323.834 377.67L318.977 386.08H328.691L323.834 377.67Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M272.803 426.08H246.495V434.836H272.803V426.08Z",
    fill: "#855914"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M270.248 434.836H249.037V438.721H270.248V434.836Z",
    fill: "#2B2A25"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M397.885 426.08H371.578V434.836H397.885V426.08Z",
    fill: "#855914"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M395.331 434.836H374.12V438.721H395.331V434.836Z",
    fill: "#2B2A25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M598.816 426.08H572.509V434.836H598.816V426.08Z",
    fill: "#855914"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M596.261 434.836H575.051V438.721H596.261V434.836Z",
    fill: "#2B2A25"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4490_4425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.74 194.96V198.31H365.99V200.71H360.55C358.47 200.71 356.78 199.03 356.78 196.95C356.78 195.91 357.2 194.97 357.89 194.29C358.57 193.6 359.51 193.18 360.55 193.18H365.99V194.96H399.74Z",
    fill: "#BDCBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74 261.69V265.04H365.99V267.44H360.55C358.47 267.44 356.78 265.76 356.78 263.68C356.78 262.64 357.2 261.7 357.89 261.02C358.57 260.33 359.51 259.91 360.55 259.91H365.99V261.69H399.74Z",
    fill: "#BDCBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.45 187.939H399.74V191.289H358.45C357.53 191.289 356.78 190.539 356.78 189.619C356.78 188.699 357.53 187.949 358.45 187.949V187.939Z",
    fill: "#BDCBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.45 229.471H399.74V232.821H358.45C357.53 232.821 356.78 232.071 356.78 231.151C356.78 230.231 357.53 229.481 358.45 229.481V229.471Z",
    fill: "#BDCBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.45 271H399.74V274.35H358.45C357.53 274.35 356.78 273.6 356.78 272.68C356.78 271.76 357.53 271.01 358.45 271.01V271Z",
    fill: "#BDCBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.39 226.949H345.08V231.979H313.39C312 231.979 310.87 230.849 310.87 229.459C310.87 228.069 312 226.939 313.39 226.939V226.949Z",
    fill: "url(#paint0_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.08 245.16H279.85V210.41H337.47V218.94L307.8 222.53C304.8 223.75 302.84 226.67 302.84 229.91C302.84 233.53 305.28 236.7 308.78 237.62L345.06 238.25V245.17L345.08 245.16Z",
    fill: "url(#paint1_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.43 224.811H322.07V234.121H308.43C307.14 234.121 306.09 233.071 306.09 231.781V227.151C306.09 225.861 307.14 224.811 308.43 224.811Z",
    fill: "url(#paint2_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.69 170.939H276.06C273.437 170.939 271.31 173.066 271.31 175.689V179.899C271.31 182.523 273.437 184.649 276.06 184.649H537.69C540.313 184.649 542.44 182.523 542.44 179.899V175.689C542.44 173.066 540.313 170.939 537.69 170.939Z",
    fill: "url(#paint3_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.03 276.58H275.8C273.326 276.58 271.32 278.586 271.32 281.06V284.03C271.32 286.504 273.326 288.51 275.8 288.51H544.03C546.504 288.51 548.51 286.504 548.51 284.03V281.06C548.51 278.586 546.504 276.58 544.03 276.58Z",
    fill: "url(#paint4_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.62 184.641H367.01V276.581H379.62V184.641Z",
    fill: "#E86F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.06 184.641H379.63V276.581H394.06V184.641Z",
    fill: "#9FADB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.74 184.641H394.06V276.581H399.74V184.641Z",
    fill: "#BDCBD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.15 184.641H399.74V276.581H404.15V184.641Z",
    fill: "#A8C4CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.01 184.641H348.31L342.62 194.881L336.31 206.701L336.2 220.771L342.48 221.481L342.62 243.291L301.23 258.401V276.581H367.01V184.641Z",
    fill: "#818F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71 206.24H270.5V210.42H311.71V206.24Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.5 168.98H559.93C562.17 168.98 563.99 170.8 563.99 173.04V187.49C563.99 189.73 562.17 191.55 559.93 191.55H548.5V168.98Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.65 191.42H530.9C533.93 191.42 536.4 193.88 536.4 196.92V204.92C536.4 207.95 533.94 210.42 530.9 210.42H502.65V191.43V191.42Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.76 197.84H314.61V210.42H330.76V197.84Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.21 143.92H379.63V170.93H392.21V143.92Z",
    fill: "#77878A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63 137H365.68V165.09H379.63V137Z",
    fill: "#BECCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.99 165.09H379.63V171.07H353.74V168.34C353.74 166.55 355.2 165.09 356.99 165.09Z",
    fill: "#E86F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.82 137H379.63V143.92H393.82V137Z",
    fill: "#BECCD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.37 184.641H319.29V197.831H327.37V184.641Z",
    fill: "#0E1D42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.71 251.039H270.5V255.219H311.71V251.039Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.36 225.09H271.31V236.99H279.36V225.09Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.12 236.99H273.57V251.11H277.12V236.99Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.12 210.689H273.57V224.809H277.12V210.689Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 184.641H403.96V276.581H417.77V184.641Z",
    fill: "#818F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.46 184.641H466.24V276.601H490.46V184.641Z",
    fill: "#818F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.81 164.82H468.08V171.07H501.81V164.82Z",
    fill: "#818F94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.94 153H486.17C490.01 153 493.12 156.12 493.12 159.95V164.81H471.98V159.95C471.98 156.11 475.1 153 478.93 153H478.94Z",
    fill: "url(#paint5_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.82 161.311H495.08V164.821H500.82V161.311Z",
    fill: "url(#paint6_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.65 184.641H490.54V276.581H502.65V184.641Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.5 166.83H536.39V286.13H548.5V166.83Z",
    fill: "url(#paint7_linear_4490_4425)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.4 211.35H502.65V271H536.4V211.35Z",
    fill: "#BBBFB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.1 300.62V288.51H271.11V300.62H550.1Z",
    fill: "#BBBFB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 187.61H407.19C408.3 187.61 409.2 188.51 409.2 189.62C409.2 190.73 408.3 191.63 407.19 191.63H403.74V187.6V187.61Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 195.16H407.19C408.3 195.16 409.2 196.06 409.2 197.17C409.2 198.28 408.3 199.18 407.19 199.18H403.74V195.15V195.16Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 202.709H407.19C408.3 202.709 409.2 203.609 409.2 204.719C409.2 205.829 408.3 206.729 407.19 206.729H403.74V202.699V202.709Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 210.26H407.19C408.3 210.26 409.2 211.16 409.2 212.27C409.2 213.38 408.3 214.28 407.19 214.28H403.74V210.25V210.26Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 217.811H407.19C408.3 217.811 409.2 218.711 409.2 219.821C409.2 220.931 408.3 221.831 407.19 221.831H403.74V217.801V217.811Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 225.36H407.19C408.3 225.36 409.2 226.26 409.2 227.37C409.2 228.48 408.3 229.38 407.19 229.38H403.74V225.35V225.36Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 232.91H407.19C408.3 232.91 409.2 233.81 409.2 234.92C409.2 236.03 408.3 236.93 407.19 236.93H403.74V232.9V232.91Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 240.459H407.19C408.3 240.459 409.2 241.359 409.2 242.469C409.2 243.579 408.3 244.479 407.19 244.479H403.74V240.449V240.459Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 248.01H407.19C408.3 248.01 409.2 248.91 409.2 250.02C409.2 251.13 408.3 252.03 407.19 252.03H403.74V248V248.01Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 255.561H407.19C408.3 255.561 409.2 256.461 409.2 257.571C409.2 258.681 408.3 259.581 407.19 259.581H403.74V255.551V255.561Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 263.11H407.19C408.3 263.11 409.2 264.01 409.2 265.12C409.2 266.23 408.3 267.13 407.19 267.13H403.74V263.1V263.11Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.74 270.66H407.19C408.3 270.66 409.2 271.56 409.2 272.67C409.2 273.78 408.3 274.68 407.19 274.68H403.74V270.65V270.66Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 187.61H419.08C419.87 187.61 420.5 188.25 420.5 189.03V190.21C420.5 191 419.86 191.63 419.08 191.63H417.77V187.6V187.61Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 195.16H419.08C419.87 195.16 420.5 195.8 420.5 196.58V197.76C420.5 198.55 419.86 199.18 419.08 199.18H417.77V195.15V195.16Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 202.709H419.08C419.87 202.709 420.5 203.349 420.5 204.129V205.309C420.5 206.099 419.86 206.729 419.08 206.729H417.77V202.699V202.709Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 210.26H419.08C419.87 210.26 420.5 210.9 420.5 211.68V212.86C420.5 213.65 419.86 214.28 419.08 214.28H417.77V210.25V210.26Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 217.811H419.08C419.87 217.811 420.5 218.451 420.5 219.231V220.411C420.5 221.201 419.86 221.831 419.08 221.831H417.77V217.801V217.811Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 225.36H419.08C419.87 225.36 420.5 226 420.5 226.78V227.96C420.5 228.75 419.86 229.38 419.08 229.38H417.77V225.35V225.36Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 232.91H419.08C419.87 232.91 420.5 233.55 420.5 234.33V235.51C420.5 236.3 419.86 236.93 419.08 236.93H417.77V232.9V232.91Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 240.459H419.08C419.87 240.459 420.5 241.099 420.5 241.879V243.059C420.5 243.849 419.86 244.479 419.08 244.479H417.77V240.449V240.459Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 248.01H419.08C419.87 248.01 420.5 248.65 420.5 249.43V250.61C420.5 251.4 419.86 252.03 419.08 252.03H417.77V248V248.01Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 255.561H419.08C419.87 255.561 420.5 256.201 420.5 256.981V258.161C420.5 258.951 419.86 259.581 419.08 259.581H417.77V255.551V255.561Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 263.11H419.08C419.87 263.11 420.5 263.75 420.5 264.53V265.71C420.5 266.5 419.86 267.13 419.08 267.13H417.77V263.1V263.11Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.77 270.66H419.08C419.87 270.66 420.5 271.3 420.5 272.08V273.26C420.5 274.05 419.86 274.68 419.08 274.68H417.77V270.65V270.66Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 269.52H465.01C464.77 269.52 464.58 269.33 464.58 269.09V268.85C464.58 268.61 464.77 268.42 465.01 268.42H466.24V269.52Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 265.91H462.92C462.62 265.91 462.37 265.66 462.37 265.36C462.37 265.06 462.62 264.81 462.92 264.81H466.24V265.91Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 258.699H462.92C462.62 258.699 462.37 258.449 462.37 258.149C462.37 257.849 462.62 257.599 462.92 257.599H466.24V258.699Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 251.48H462.92C462.62 251.48 462.37 251.23 462.37 250.93C462.37 250.63 462.62 250.38 462.92 250.38H466.24V251.48Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 244.27H462.92C462.62 244.27 462.37 244.02 462.37 243.72C462.37 243.42 462.62 243.17 462.92 243.17H466.24V244.27Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 237.061H462.92C462.62 237.061 462.37 236.811 462.37 236.511C462.37 236.211 462.62 235.961 462.92 235.961H466.24V237.061Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 229.84H462.92C462.62 229.84 462.37 229.59 462.37 229.29C462.37 228.99 462.62 228.74 462.92 228.74H466.24V229.84Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 222.631H462.92C462.62 222.631 462.37 222.381 462.37 222.081C462.37 221.781 462.62 221.531 462.92 221.531H466.24V222.631Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 215.42H462.92C462.62 215.42 462.37 215.17 462.37 214.87C462.37 214.57 462.62 214.32 462.92 214.32H466.24V215.42Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 208.199H462.92C462.62 208.199 462.37 207.949 462.37 207.649C462.37 207.349 462.62 207.099 462.92 207.099H466.24V208.199Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 200.99H462.92C462.62 200.99 462.37 200.74 462.37 200.44C462.37 200.14 462.62 199.89 462.92 199.89H466.24V200.99Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 193.779H462.92C462.62 193.779 462.37 193.529 462.37 193.229C462.37 192.929 462.62 192.679 462.92 192.679H466.24V193.779Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 262.301H465.01C464.77 262.301 464.58 262.111 464.58 261.871V261.631C464.58 261.391 464.77 261.201 465.01 261.201H466.24V262.301Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 255.09H465.01C464.77 255.09 464.58 254.9 464.58 254.66V254.42C464.58 254.18 464.77 253.99 465.01 253.99H466.24V255.09Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 247.881H465.01C464.77 247.881 464.58 247.691 464.58 247.451V247.211C464.58 246.971 464.77 246.781 465.01 246.781H466.24V247.881Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 240.66H465.01C464.77 240.66 464.58 240.47 464.58 240.23V239.99C464.58 239.75 464.77 239.56 465.01 239.56H466.24V240.66Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 233.449H465.01C464.77 233.449 464.58 233.259 464.58 233.019V232.779C464.58 232.539 464.77 232.349 465.01 232.349H466.24V233.449Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 226.24H465.01C464.77 226.24 464.58 226.05 464.58 225.81V225.57C464.58 225.33 464.77 225.14 465.01 225.14H466.24V226.24Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 219.02H465.01C464.77 219.02 464.58 218.83 464.58 218.59V218.35C464.58 218.11 464.77 217.92 465.01 217.92H466.24V219.02Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 211.811H465.01C464.77 211.811 464.58 211.621 464.58 211.381V211.141C464.58 210.901 464.77 210.711 465.01 210.711H466.24V211.811Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 204.6H465.01C464.77 204.6 464.58 204.41 464.58 204.17V203.93C464.58 203.69 464.77 203.5 465.01 203.5H466.24V204.6Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 197.381H465.01C464.77 197.381 464.58 197.191 464.58 196.951V196.711C464.58 196.471 464.77 196.281 465.01 196.281H466.24V197.381Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.24 190.17H465.01C464.77 190.17 464.58 189.98 464.58 189.74V189.5C464.58 189.26 464.77 189.07 465.01 189.07H466.24V190.17Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.29 211.539H536.39V252.039H516.19C512.93 252.039 510.29 249.399 510.29 246.139V211.539Z",
    fill: "#898C81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.93 268.961H504.83V287.531H530.93V268.961Z",
    fill: "#BABFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.41 263.56C537.41 259.981 534.509 257.08 530.93 257.08C527.351 257.08 524.45 259.981 524.45 263.56V270.71C524.45 274.289 527.351 277.19 530.93 277.19C534.509 277.19 537.41 274.289 537.41 270.71V263.56Z",
    fill: "#898C81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.61 192.32L500.82 191.49V166.03L522.82 165L535.61 192.32Z",
    fill: "#BBBFB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.5 271.92H559.41C561.94 271.92 563.99 273.97 563.99 276.5V296.05C563.99 298.58 561.94 300.63 559.41 300.63H548.5V271.93V271.92Z",
    fill: "#151E20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.79 217.75H351.76V238.86H361.79V217.75Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.79 190.16H351.76V211.27H361.79V190.16Z",
    fill: "#172A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.79 247.02H351.76V268.13H361.79V247.02Z",
    fill: "#172A30"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M217.58 74.3837V139.719L211.139 140.638V152.547L202.277 152.574L204.273 320.877L377.925 324.203V333.292H610.5V67.584L217.58 74.3837ZM314.053 308.235H270.141V156.539H314.053V308.235ZM371.272 308.235H327.36V156.539H371.272V308.235ZM372.603 137.91H220.907V79.3604L372.603 76.6991V137.91ZM447.12 325.534H384.579V148.555H447.12V325.534ZM517.646 325.534H453.773V147.224H517.646V325.534ZM548.251 131.256L383.248 133.918V76.6991L548.251 72.7071V131.256ZM605.47 133.918H557.566V72.7071H605.47V133.918Z",
    fill: "#FBD490"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8517 258.337L0.680969 266.321V432.202H131.845L140.401 427.332H152.377V346.826L217.58 327.532V321.557L204.273 320.878L202.943 254.345L201.612 249.022L157.7 251.683L148.385 234.385H140.268H104.673L104.473 243.699L96.4891 253.014H81.8517V258.337Z",
    fill: "#E8DFD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.437 272.309H11.9916V422.674H122.437V272.309Z",
    stroke: "#5E4B38",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9916 354.674H122.437",
    stroke: "#5E4B38",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3349 278.961H21.7055V305.574H40.3349V278.961Z",
    fill: "url(#paint8_linear_4490_4425)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.0082 282.953H25.0322V290.937H37.0082V282.953Z",
    fill: "#E4E2D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.3509 292.268H29.6895V294.929H32.3509V292.268Z",
    fill: "#E4E2D8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.3429 292.268H33.6815V294.929H36.3429V292.268Z",
    fill: "#E4E2D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.3588 292.268H25.6975V294.929H28.3588V292.268Z",
    fill: "#E4E2D8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.3509 296.26H29.6895V298.921H32.3509V296.26Z",
    fill: "#E4E2D8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.3429 296.26H33.6815V298.921H36.3429V296.26Z",
    fill: "#E4E2D8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.3588 296.26H25.6975V298.921H28.3588V296.26Z",
    fill: "#E4E2D8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.3509 300.25H29.6895V302.911H32.3509V300.25Z",
    fill: "#E4E2D8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.3429 300.25H33.6815V302.911H36.3429V300.25Z",
    fill: "#E4E2D8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.3588 300.25H25.6975V302.911H28.3588V300.25Z",
    fill: "#E4E2D8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M143.728 266.984V341.501L204.273 320.876L203.022 258.215L143.728 266.984Z",
    fill: "#787772"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M105.138 143.233V243.698L96.1564 252.68H81.8517V261.795H102.477L107.201 257.071H125.098V261.795L153.042 256.339L139.736 243.033V155.954C139.736 154.65 140.348 153.412 141.399 152.627L142.477 151.815C143.262 151.217 144.287 151.044 145.231 151.35L157.048 155.209C157.048 155.209 173.016 159.201 179.669 159.201H202.29V152.574L212.936 152.547L214.479 146.386C215.105 143.885 213.628 141.343 211.153 140.638L206.283 139.241L161.04 127.265L134.599 122.9C128.771 121.489 122.637 123.432 118.658 127.93L105.152 143.233H105.138Z",
    fill: "url(#paint9_linear_4490_4425)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.808 181.822H138.405C139.869 181.822 141.066 183.02 141.066 184.484H101.146C101.146 183.02 102.344 181.822 103.808 181.822Z",
    fill: "url(#paint10_linear_4490_4425)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.808 213.76H138.405C139.869 213.76 141.066 214.957 141.066 216.421H101.146C101.146 214.957 102.344 213.76 103.808 213.76Z",
    fill: "url(#paint11_linear_4490_4425)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M103.808 159.201H138.405C139.869 159.201 141.066 160.399 141.066 161.863H101.146C101.146 160.399 102.344 159.201 103.808 159.201Z",
    fill: "url(#paint12_linear_4490_4425)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M151.579 126.335V149.488C151.579 150.806 150.501 151.883 149.184 151.883V123.939C150.501 123.939 151.579 125.017 151.579 126.335Z",
    fill: "url(#paint13_linear_4490_4425)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 127.537L142.159 149.729C143.052 150.697 142.992 152.22 142.024 153.113L141.437 153.655L117.695 127.944L118.282 127.402C119.25 126.509 120.773 126.569 121.666 127.537Z",
    fill: "url(#paint14_linear_4490_4425)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.829 136.315V158.138C192.829 159.455 191.752 160.533 190.434 160.533V133.92C191.752 133.92 192.829 134.998 192.829 136.315Z",
    fill: "url(#paint15_linear_4490_4425)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M202.144 139.641V157.472C202.144 158.79 201.066 159.867 199.749 159.867V137.246C201.066 137.246 202.144 138.324 202.144 139.641Z",
    fill: "url(#paint16_linear_4490_4425)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M103.808 236.381H138.405C139.869 236.381 141.066 237.578 141.066 239.042H101.146C101.146 237.578 102.344 236.381 103.808 236.381Z",
    fill: "url(#paint17_linear_4490_4425)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M176.369 340.531V345.561L153.681 352.76L153.016 347.437L176.369 340.531Z",
    fill: "#5E4B38"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M176.422 347.783V352.813L153.734 360.012L153.069 354.689L176.422 347.783Z",
    fill: "#5E4B38"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M176.489 355.035V360.065L153.801 367.264L153.136 361.941L176.489 355.035Z",
    fill: "#5E4B38"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M176.555 362.301V367.331L153.867 374.53L153.202 369.207L176.555 362.301Z",
    fill: "#5E4B38"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M176.622 369.555V374.585L153.934 381.784L153.269 376.461L176.622 369.555Z",
    fill: "#5E4B38"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M176.675 376.818V381.848L153.987 389.047L153.322 383.725L176.675 376.818Z",
    fill: "#5E4B38"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M176.742 384.072V389.102L154.054 396.301L153.388 390.978L176.742 384.072Z",
    fill: "#5E4B38"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M176.808 391.336V396.366L154.12 403.565L153.455 398.242L176.808 391.336Z",
    fill: "#5E4B38"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M176.875 398.59V403.62L154.187 410.819L153.521 405.496L176.875 398.59Z",
    fill: "#5E4B38"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M176.928 405.84V410.883L154.24 418.082L153.575 412.759L176.928 405.84Z",
    fill: "#5E4B38"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M176.994 413.105V418.135L154.307 425.334L153.641 420.012L176.994 413.105Z",
    fill: "#5E4B38"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M179.097 339.918L199.31 382.619L220.907 372.107L202.118 333.291L179.097 339.918Z",
    fill: "#787772",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M204.38 331.935L223.568 372.108L239.283 358.974L218.831 326.865L204.38 331.935Z",
    fill: "#787772",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M214.612 321.408L148.225 346.026V427.329H152.377V346.824L217.58 324.109V321.555L214.612 321.408Z",
    fill: "#787772"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M178.325 340.172L179.097 412.241L189.636 407.371L199.31 382.62L178.325 340.172Z",
    fill: "#5E4B38"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M202.277 203.324H163.049C163.049 203.324 137.926 212.652 148.385 234.382C157.034 252.346 157.7 251.681 157.7 251.681L202.277 249.685V203.324Z",
    fill: "#E8DFD4",
    stroke: "url(#paint18_linear_4490_4425)",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M209.489 377.669C209.489 377.669 217.141 389.818 226.016 382.619C234.892 375.42 240.88 370.457 240.88 370.457V402.939C240.88 402.939 232.231 418.321 217.593 414.835C202.956 411.348 189.649 407.356 189.649 407.356L199.323 382.606L209.503 377.656L209.489 377.669Z",
    fill: "url(#paint19_linear_4490_4425)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2904 432.359H21.0801V441.115H29.2904V432.359Z",
    fill: "#855914"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4919 441.115H21.8785V445.001H28.4919V441.115Z",
    fill: "#2B2A25"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M114.453 432.359H106.243V441.115H114.453V432.359Z",
    fill: "#855914"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M113.655 441.115H107.041V445.001H113.655V441.115Z",
    fill: "#2B2A25"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3588 263.591V253.518H32.3508V263.205L28.3588 263.591Z",
    fill: "url(#paint20_linear_4490_4425)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6975 250.749V250.682C25.6975 248.78 27.2278 247.223 29.104 247.223H31.1666C33.0561 247.223 34.5731 248.766 34.5731 250.682C34.5731 252.545 33.1093 254.076 31.273 254.129L29.2105 254.195C27.281 254.249 25.6975 252.692 25.6975 250.749Z",
    fill: "#5E4B38"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M311.392 159.201H272.803V305.575H311.392V159.201Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M368.611 159.201H330.021V305.575H368.611V159.201Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M443.128 152.549H387.24V321.544H443.128V152.549Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M515.317 151.219H456.767V322.875H515.317V151.219Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M546.92 129.927L384.579 131.257V76.6998L546.92 75.3691V129.927Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M371.272 135.249L222.237 136.58V80.692L371.272 79.3613V135.249Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M602.808 74.0391H560.227V132.588H602.808V74.0391Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M320.707 148.557V314.89",
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M517.646 326.866H454.439V148.557H486.042H517.646V326.866Z",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M447.12 326.866H383.913V148.557H415.517H447.12V326.866Z",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M379.256 314.89H262.157V148.557H320.707H379.256V314.89Z",
    fill: "white",
    fillOpacity: 0.2,
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1183.25 287.861H694.119V436.763H1183.25V287.861Z",
    fill: "#E8DFD4",
    stroke: "#A55926",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M776.341 347.74H773.24V372.278H776.341V347.74Z",
    fill: "#855914"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M772.282 347.74H769.182V372.278H772.282V347.74Z",
    fill: "#855914"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M768.21 347.74H765.11V372.278H768.21V347.74Z",
    fill: "#855914"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M764.138 347.74H761.038V372.278H764.138V347.74Z",
    fill: "#855914"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M760.08 347.74H756.979V372.278H760.08V347.74Z",
    fill: "#855914"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M756.008 347.74H752.908V372.278H756.008V347.74Z",
    fill: "#855914"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M751.936 347.74H748.836V372.278H751.936V347.74Z",
    fill: "#855914"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M747.864 347.74H744.764V372.278H747.864V347.74Z",
    fill: "#855914"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M729.807 324.428H707.412V337.415H729.807V324.428Z",
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M728.583 325.52H722.089V335.885H728.583V325.52Z",
    fill: "#855914"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M729.807 341.248H707.412V354.235H729.807V341.248Z",
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M728.583 342.285H722.089V353.183H728.583V342.285Z",
    fill: "#855914"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M729.807 358.014H707.412V371.001H729.807V358.014Z",
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M728.583 359.064H722.089V369.963H728.583V359.064Z",
    fill: "#855914"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.52 322.338H1089.13V335.325H1111.52V322.338Z",
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.3 323.43H1103.8V333.796H1110.3V323.43Z",
    fill: "#855914"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.52 339.158H1089.13V352.146H1111.52V339.158Z",
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.3 340.195H1103.8V351.093H1110.3V340.195Z",
    fill: "#855914"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.52 355.924H1089.13V368.911H1111.52V355.924Z",
    stroke: "#855914",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.3 356.961H1103.8V367.859H1110.3V356.961Z",
    fill: "#855914"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M936.367 298.877L931.51 307.287H941.224L936.367 298.877L931.51 307.287H941.224L936.367 298.877Z",
    fill: "#FFCE09"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M936.367 298.877L931.51 307.287H941.224L936.367 298.877ZM936.367 298.877L931.51 307.287H941.224L936.367 298.877Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.61 318.094C1097.77 318.094 1098.71 317.152 1098.71 315.991C1098.71 314.83 1097.77 313.889 1096.61 313.889C1095.44 313.889 1094.5 314.83 1094.5 315.991C1094.5 317.152 1095.44 318.094 1096.61 318.094Z",
    fill: "#A45825"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1103.8 318.094C1104.97 318.094 1105.91 317.152 1105.91 315.991C1105.91 314.83 1104.97 313.889 1103.8 313.889C1102.64 313.889 1101.7 314.83 1101.7 315.991C1101.7 317.152 1102.64 318.094 1103.8 318.094Z",
    fill: "#A45825"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M828.876 318.24H822.062V325.053H828.876V318.24Z",
    fill: "#A45825"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M800.838 287.861V436.776",
    stroke: "#A45826",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M924.178 287.861V436.776",
    stroke: "#A45826",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.54 287.861V436.776",
    stroke: "#A45826",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.1 287.861V436.776",
    stroke: "#A45826",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M611.524 181.966H628.011V158.24H611.524",
    fill: "url(#paint21_linear_4490_4425)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M666.228 393.143H692.988L694.119 436.775L682.821 420.009H666.228H638.563L635.13 425.331L610.5 420.674L611.524 293.489V264.321L661.65 265.625V256.576H763.926L767.159 261.5H778.709L800.838 266.157L801.251 270.894H785.203L783.007 283.363L694.119 287.86L666.228 393.143Z",
    fill: "#56A4D3"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M685.243 283.92L1156.25 281.232L1183.25 287.859H694.119L692.988 393.142L677.166 393.993L666.228 393.142L669.621 302.55L685.083 301.685L685.243 283.92Z",
    fill: "#56A4D3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1169.34 270.895L1167.61 281.234L783.007 283.363L786.001 270.895H1169.34Z",
    fill: "#56A4D3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M747.864 260.449H672.455V270.895H624.059L615.756 405.678H622.968L631.125 280.143H755.715H1165.85V275.06H763.926L747.864 260.449Z",
    fill: "#3284AD"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M776.341 312.705H773.24V338.334H776.341V312.705Z",
    fill: "#855914"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M772.282 312.705H769.182V338.334H772.282V312.705Z",
    fill: "#855914"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M768.21 312.705H765.11V338.334H768.21V312.705Z",
    fill: "#855914"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M764.138 312.705H761.038V338.334H764.138V312.705Z",
    fill: "#855914"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M760.08 312.705H756.979V338.334H760.08V312.705Z",
    fill: "#855914"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M756.008 312.705H752.908V338.334H756.008V312.705Z",
    fill: "#855914"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M751.936 312.705H748.836V338.334H751.936V312.705Z",
    fill: "#855914"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M747.864 312.705H744.764V338.334H747.864V312.705Z",
    fill: "#855914"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M825.469 160.211H855.994C860.545 160.211 864.258 163.91 864.258 168.474V173.717C864.258 178.268 860.559 181.981 855.994 181.981H825.469V160.224V160.211Z",
    fill: "#E8DFD4",
    stroke: "url(#paint22_linear_4490_4425)",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M801.251 12.9336C801.251 12.9336 715.955 30.0726 806.467 166.932",
    stroke: "url(#paint23_linear_4490_4425)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M801.45 38.2422C801.45 38.2422 761.025 81.0897 806.48 154.13",
    stroke: "url(#paint24_linear_4490_4425)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M660.692 240.37H800.838V210.164H655.915V214.475H660.346L660.692 240.37Z",
    fill: "url(#paint25_linear_4490_4425)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M723.354 213.584H658.031V217.483H723.354V213.584Z",
    fill: "url(#paint26_linear_4490_4425)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M724.431 210.164V219.785H726.454V214.023V210.164H724.431Z",
    fill: "url(#paint27_linear_4490_4425)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M800.838 213.584V217.496H726.454V213.584",
    fill: "url(#paint28_linear_4490_4425)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M831.111 74.6489H799.72V4.49605L802.036 3.43151C809.834 -0.147989 818.749 -0.387509 826.733 2.76617L831.111 4.49605V74.6489Z",
    fill: "url(#paint29_linear_4490_4425)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M838.669 74.6484H791.164V102.646H838.669V74.6484Z",
    fill: "url(#paint30_linear_4490_4425)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M826.334 130.657H803.5L792.921 102.646H837.086L826.334 130.657Z",
    fill: "url(#paint31_linear_4490_4425)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M803.673 130.656H826.507L826.693 211.88H803.287L803.673 130.656Z",
    fill: "url(#paint32_linear_4490_4425)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M835.968 131.161L843.726 121.315V65.1337C843.726 65.1337 861.73 56.8304 870.033 65.1337C870.858 75.9388 870.033 114.701 870.033 114.701L835.968 131.161Z",
    fill: "url(#paint33_linear_4490_4425)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M801.45 25.1621H829.394C830.858 25.1621 832.056 26.3597 832.056 27.8234H798.789C798.789 26.3597 799.987 25.1621 801.45 25.1621Z",
    fill: "url(#paint34_linear_4490_4425)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M801.45 38.2422H829.394C830.858 38.2422 832.056 39.4398 832.056 40.9035H798.789C798.789 39.4398 799.987 38.2422 801.45 38.2422Z",
    fill: "url(#paint35_linear_4490_4425)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M793.826 101.316H837.338C838.802 101.316 840 102.514 840 103.978H791.164C791.164 102.514 792.362 101.316 793.826 101.316Z",
    fill: "url(#paint36_linear_4490_4425)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M868.702 80.7969H844.99C844.255 80.7969 843.659 81.3926 843.659 82.1275C843.659 82.8625 844.255 83.4582 844.99 83.4582H868.702C869.437 83.4582 870.033 82.8625 870.033 82.1275C870.033 81.3926 869.437 80.7969 868.702 80.7969Z",
    fill: "url(#paint37_linear_4490_4425)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M848.303 121.104V85.6546C848.303 84.5501 848.596 83.6719 848.968 83.6719C849.341 83.6719 849.634 84.5634 849.634 85.6546V121.104C849.634 122.208 849.341 123.086 848.968 123.086C848.596 123.086 848.303 122.195 848.303 121.104Z",
    fill: "url(#paint38_linear_4490_4425)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M854.065 118.666V85.5192C854.065 84.4946 854.358 83.6562 854.73 83.6562C855.103 83.6562 855.396 84.4946 855.396 85.5192V118.666C855.396 119.691 855.103 120.529 854.73 120.529C854.358 120.529 854.065 119.691 854.065 118.666Z",
    fill: "url(#paint39_linear_4490_4425)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M859.84 116.739V85.4283C859.84 84.457 860.133 83.6719 860.505 83.6719C860.878 83.6719 861.171 84.457 861.171 85.4283V116.739C861.171 117.71 860.878 118.495 860.505 118.495C860.133 118.495 859.84 117.71 859.84 116.739Z",
    fill: "url(#paint40_linear_4490_4425)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M865.735 114.501V85.293C865.735 84.3881 866.028 83.6562 866.4 83.6562C866.773 83.6562 867.066 84.3881 867.066 85.293V114.501C867.066 115.406 866.773 116.138 866.4 116.138C866.028 116.138 865.735 115.406 865.735 114.501Z",
    fill: "url(#paint41_linear_4490_4425)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M803.912 129.326H824.577C826.041 129.326 827.239 130.524 827.239 131.988H801.251C801.251 130.524 802.448 129.326 803.912 129.326Z",
    fill: "url(#paint42_linear_4490_4425)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M870.658 99.9043H862.368V111.814H870.658V99.9043Z",
    fill: "white",
    stroke: "url(#paint43_linear_4490_4425)",
    strokeWidth: 0.62,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M960.372 210.164V248.368H1025.92C1025.92 248.368 1043.79 210.164 1025.92 210.164H960.372Z",
    fill: "url(#paint44_linear_4490_4425)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.93 190.75H979.853V210.164H1025.93V190.75Z",
    fill: "url(#paint45_linear_4490_4425)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M800.838 196.139H952.122C956.673 196.139 960.385 199.838 960.385 204.402V244.083C960.385 248.634 956.686 252.346 952.122 252.346H800.838V196.152V196.139Z",
    fill: "#E8DFD4",
    stroke: "url(#paint46_linear_4490_4425)",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M826.693 136.471L870.033 114.701V153.344H826.56L826.693 136.471Z",
    fill: "#E8DFD4",
    stroke: "url(#paint47_linear_4490_4425)",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M870.858 195.526C870.858 195.526 868.077 197.296 859.827 181.967",
    stroke: "url(#paint48_linear_4490_4425)",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M883.885 196.139C883.885 196.139 872.495 192.773 864.245 177.443",
    stroke: "url(#paint49_linear_4490_4425)",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.49 252.348H801.251V270.897H1203.49V252.348Z",
    fill: "#E8DFD4"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.48 210.168H801.251V217.008H1208.48V210.168Z",
    fill: "url(#paint50_linear_4490_4425)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.48 163.514H801.251V170.353H1208.48V163.514Z",
    fill: "url(#paint51_linear_4490_4425)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.54 118.723H797.472V125.562H1213.54V118.723Z",
    fill: "url(#paint52_linear_4490_4425)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M939.787 252.349V123.594H932.947V252.349H939.787Z",
    fill: "url(#paint53_linear_4490_4425)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M949.9 252.361V123.605H943.06V252.361H949.9Z",
    fill: "url(#paint54_linear_4490_4425)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.98 252.349V123.594H1067.14V252.349H1073.98Z",
    fill: "url(#paint55_linear_4490_4425)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1084.1 252.349V123.594H1077.26V252.349H1084.1Z",
    fill: "url(#paint56_linear_4490_4425)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1198.36 252.349V123.594H1191.52V252.349H1198.36Z",
    fill: "url(#paint57_linear_4490_4425)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.48 252.349V123.594H1201.64V252.349H1208.48Z",
    fill: "url(#paint58_linear_4490_4425)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M776.939 129.328L777.924 210.166H783.007V129.328H776.939Z",
    fill: "url(#paint59_linear_4490_4425)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M801.251 252.349L781.637 247.945V240.373H778.709V261.504L800.838 266.161L801.251 252.349Z",
    fill: "#E8DFD4"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.17 265.362L1241.26 440.997H1254.77L1230.07 261.623H1201.64V265.362H1215.17Z",
    fill: "url(#paint60_linear_4490_4425)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1213.53 125.563L1246.69 252.349V333.786L1240.89 340.199L1241.37 343.726L1251.59 339.161L1252.79 252.881C1252.81 251.244 1252.61 249.621 1252.19 248.051L1217.83 118.736H1213.52V125.576L1213.53 125.563Z",
    fill: "url(#paint61_linear_4490_4425)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M778.709 168.969L801.251 163.514V170.353L778.709 174.638V168.969Z",
    fill: "url(#paint62_linear_4490_4425)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M778.709 124.178L801.251 118.723V125.562L778.709 129.847V124.178Z",
    fill: "url(#paint63_linear_4490_4425)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1200.36 305.148H1183.25V386.599H1200.36V305.148Z",
    fill: "#E8DFD4",
    stroke: "#A55926",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M659.506 215.088L610.127 214.771V201.781H660.692L659.506 215.088Z",
    fill: "#3284AD"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M658.031 264.324H611.524V254.929V216.406H658.031V254.384V264.324Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M655.915 219.227H614.345V252.347H655.915V219.227Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M615.09 256.578H614.305C613.938 256.578 613.64 256.876 613.64 257.243V258.029C613.64 258.396 613.938 258.694 614.305 258.694H615.09C615.458 258.694 615.756 258.396 615.756 258.029V257.243C615.756 256.876 615.458 256.578 615.09 256.578Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M618.177 256.578H617.392C617.025 256.578 616.727 256.876 616.727 257.243V258.029C616.727 258.396 617.025 258.694 617.392 258.694H618.177C618.545 258.694 618.843 258.396 618.843 258.029V257.243C618.843 256.876 618.545 256.578 618.177 256.578Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M621.265 256.578H620.48C620.112 256.578 619.814 256.876 619.814 257.243V258.029C619.814 258.396 620.112 258.694 620.48 258.694H621.265C621.632 258.694 621.93 258.396 621.93 258.029V257.243C621.93 256.876 621.632 256.578 621.265 256.578Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M624.352 256.578H623.567C623.199 256.578 622.901 256.876 622.901 257.243V258.029C622.901 258.396 623.199 258.694 623.567 258.694H624.352C624.719 258.694 625.017 258.396 625.017 258.029V257.243C625.017 256.876 624.719 256.578 624.352 256.578Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M627.452 256.578H626.667C626.3 256.578 626.002 256.876 626.002 257.243V258.029C626.002 258.396 626.3 258.694 626.667 258.694H627.452C627.82 258.694 628.118 258.396 628.118 258.029V257.243C628.118 256.876 627.82 256.578 627.452 256.578Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M630.539 256.578H629.754C629.387 256.578 629.089 256.876 629.089 257.243V258.029C629.089 258.396 629.387 258.694 629.754 258.694H630.539C630.907 258.694 631.205 258.396 631.205 258.029V257.243C631.205 256.876 630.907 256.578 630.539 256.578Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M633.626 256.578H632.841C632.474 256.578 632.176 256.876 632.176 257.243V258.029C632.176 258.396 632.474 258.694 632.841 258.694H633.626C633.994 258.694 634.292 258.396 634.292 258.029V257.243C634.292 256.876 633.994 256.578 633.626 256.578Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M636.714 256.578H635.929C635.561 256.578 635.263 256.876 635.263 257.243V258.029C635.263 258.396 635.561 258.694 635.929 258.694H636.714C637.081 258.694 637.379 258.396 637.379 258.029V257.243C637.379 256.876 637.081 256.578 636.714 256.578Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M639.801 256.578H639.016C638.648 256.578 638.35 256.876 638.35 257.243V258.029C638.35 258.396 638.648 258.694 639.016 258.694H639.801C640.168 258.694 640.466 258.396 640.466 258.029V257.243C640.466 256.876 640.168 256.578 639.801 256.578Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M642.888 256.578H642.103C641.735 256.578 641.438 256.876 641.438 257.243V258.029C641.438 258.396 641.735 258.694 642.103 258.694H642.888C643.255 258.694 643.553 258.396 643.553 258.029V257.243C643.553 256.876 643.255 256.578 642.888 256.578Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M645.988 256.578H645.203C644.836 256.578 644.538 256.876 644.538 257.243V258.029C644.538 258.396 644.836 258.694 645.203 258.694H645.988C646.356 258.694 646.654 258.396 646.654 258.029V257.243C646.654 256.876 646.356 256.578 645.988 256.578Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M649.076 256.578H648.29C647.923 256.578 647.625 256.876 647.625 257.243V258.029C647.625 258.396 647.923 258.694 648.29 258.694H649.076C649.443 258.694 649.741 258.396 649.741 258.029V257.243C649.741 256.876 649.443 256.578 649.076 256.578Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M652.163 256.578H651.378C651.01 256.578 650.712 256.876 650.712 257.243V258.029C650.712 258.396 651.01 258.694 651.378 258.694H652.163C652.53 258.694 652.828 258.396 652.828 258.029V257.243C652.828 256.876 652.53 256.578 652.163 256.578Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M655.25 256.578H654.465C654.097 256.578 653.799 256.876 653.799 257.243V258.029C653.799 258.396 654.097 258.694 654.465 258.694H655.25C655.617 258.694 655.915 258.396 655.915 258.029V257.243C655.915 256.876 655.617 256.578 655.25 256.578Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M615.09 259.389H614.305C613.938 259.389 613.64 259.687 613.64 260.054V260.839C613.64 261.207 613.938 261.504 614.305 261.504H615.09C615.458 261.504 615.756 261.207 615.756 260.839V260.054C615.756 259.687 615.458 259.389 615.09 259.389Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M618.177 259.389H617.392C617.025 259.389 616.727 259.687 616.727 260.054V260.839C616.727 261.207 617.025 261.504 617.392 261.504H618.177C618.545 261.504 618.843 261.207 618.843 260.839V260.054C618.843 259.687 618.545 259.389 618.177 259.389Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M621.265 259.389H620.48C620.112 259.389 619.814 259.687 619.814 260.054V260.839C619.814 261.207 620.112 261.504 620.48 261.504H621.265C621.632 261.504 621.93 261.207 621.93 260.839V260.054C621.93 259.687 621.632 259.389 621.265 259.389Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M624.352 259.389H623.567C623.199 259.389 622.901 259.687 622.901 260.054V260.839C622.901 261.207 623.199 261.504 623.567 261.504H624.352C624.719 261.504 625.017 261.207 625.017 260.839V260.054C625.017 259.687 624.719 259.389 624.352 259.389Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M627.452 259.389H626.667C626.3 259.389 626.002 259.687 626.002 260.054V260.839C626.002 261.207 626.3 261.504 626.667 261.504H627.452C627.82 261.504 628.118 261.207 628.118 260.839V260.054C628.118 259.687 627.82 259.389 627.452 259.389Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M630.539 259.389H629.754C629.387 259.389 629.089 259.687 629.089 260.054V260.839C629.089 261.207 629.387 261.504 629.754 261.504H630.539C630.907 261.504 631.205 261.207 631.205 260.839V260.054C631.205 259.687 630.907 259.389 630.539 259.389Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M633.626 259.389H632.841C632.474 259.389 632.176 259.687 632.176 260.054V260.839C632.176 261.207 632.474 261.504 632.841 261.504H633.626C633.994 261.504 634.292 261.207 634.292 260.839V260.054C634.292 259.687 633.994 259.389 633.626 259.389Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M636.714 259.389H635.929C635.561 259.389 635.263 259.687 635.263 260.054V260.839C635.263 261.207 635.561 261.504 635.929 261.504H636.714C637.081 261.504 637.379 261.207 637.379 260.839V260.054C637.379 259.687 637.081 259.389 636.714 259.389Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M639.801 259.389H639.016C638.648 259.389 638.35 259.687 638.35 260.054V260.839C638.35 261.207 638.648 261.504 639.016 261.504H639.801C640.168 261.504 640.466 261.207 640.466 260.839V260.054C640.466 259.687 640.168 259.389 639.801 259.389Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M642.888 259.389H642.103C641.735 259.389 641.438 259.687 641.438 260.054V260.839C641.438 261.207 641.735 261.504 642.103 261.504H642.888C643.255 261.504 643.553 261.207 643.553 260.839V260.054C643.553 259.687 643.255 259.389 642.888 259.389Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M645.988 259.389H645.203C644.836 259.389 644.538 259.687 644.538 260.054V260.839C644.538 261.207 644.836 261.504 645.203 261.504H645.988C646.356 261.504 646.654 261.207 646.654 260.839V260.054C646.654 259.687 646.356 259.389 645.988 259.389Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M649.076 259.389H648.29C647.923 259.389 647.625 259.687 647.625 260.054V260.839C647.625 261.207 647.923 261.504 648.29 261.504H649.076C649.443 261.504 649.741 261.207 649.741 260.839V260.054C649.741 259.687 649.443 259.389 649.076 259.389Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M652.163 259.389H651.378C651.01 259.389 650.712 259.687 650.712 260.054V260.839C650.712 261.207 651.01 261.504 651.378 261.504H652.163C652.53 261.504 652.828 261.207 652.828 260.839V260.054C652.828 259.687 652.53 259.389 652.163 259.389Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M655.25 259.389H654.465C654.097 259.389 653.799 259.687 653.799 260.054V260.839C653.799 261.207 654.097 261.504 654.465 261.504H655.25C655.617 261.504 655.915 261.207 655.915 260.839V260.054C655.915 259.687 655.617 259.389 655.25 259.389Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M611.524 254.504H658.031",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4490_4425",
    x1: 310.87,
    y1: 229.469,
    x2: 345.08,
    y2: 229.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4490_4425",
    x1: 279.85,
    y1: 227.79,
    x2: 271.5,
    y2: 227.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4490_4425",
    x1: 306.09,
    y1: 229.471,
    x2: 322.07,
    y2: 229.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4490_4425",
    x1: 406.88,
    y1: 165.119,
    x2: 406.88,
    y2: 183.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4490_4425",
    x1: 409.91,
    y1: 271.94,
    x2: 409.91,
    y2: 290.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4490_4425",
    x1: 471.99,
    y1: 158.91,
    x2: 493.13,
    y2: 158.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4490_4425",
    x1: 495.08,
    y1: 163.061,
    x2: 500.82,
    y2: 163.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4490_4425",
    x1: 536.39,
    y1: 226.48,
    x2: 548.5,
    y2: 226.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BAB8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D5D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4490_4425",
    x1: 21.7055,
    y1: 292.268,
    x2: 40.3349,
    y2: 292.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4490_4425",
    x1: 86.1631,
    y1: 194.21,
    x2: 188.678,
    y2: 189.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4490_4425",
    x1: 103.342,
    y1: 184.111,
    x2: 132.87,
    y2: 182.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4490_4425",
    x1: 103.342,
    y1: 216.049,
    x2: 132.87,
    y2: 214.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4490_4425",
    x1: 103.342,
    y1: 161.49,
    x2: 132.87,
    y2: 160.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4490_4425",
    x1: 149.702,
    y1: 125.47,
    x2: 150.74,
    y2: 146.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4490_4425",
    x1: 119.669,
    y1: 129.042,
    x2: 138.173,
    y2: 147.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4490_4425",
    x1: 190.98,
    y1: 135.37,
    x2: 191.964,
    y2: 155.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4490_4425",
    x1: 200.388,
    y1: 138.47,
    x2: 201.226,
    y2: 155.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4490_4425",
    x1: 103.342,
    y1: 238.67,
    x2: 132.87,
    y2: 237.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4490_4425",
    x1: 145.165,
    y1: 227.502,
    x2: 202.943,
    y2: 227.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4490_4425",
    x1: 189.636,
    y1: 392.919,
    x2: 240.867,
    y2: 392.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4490_4425",
    x1: 28.3588,
    y1: 258.561,
    x2: 32.3508,
    y2: 258.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4490_4425",
    x1: 611.524,
    y1: 170.11,
    x2: 628.011,
    y2: 170.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4490_4425",
    x1: 824.804,
    y1: 171.096,
    x2: 864.91,
    y2: 171.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4490_4425",
    x1: 762.848,
    y1: 89.5002,
    x2: 808.144,
    y2: 89.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A97C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4490_4425",
    x1: 782.888,
    y1: 96.0331,
    x2: 808.17,
    y2: 96.0331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A97C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4490_4425",
    x1: 655.915,
    y1: 225.267,
    x2: 800.838,
    y2: 225.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4490_4425",
    x1: 658.031,
    y1: 215.54,
    x2: 723.34,
    y2: 215.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4490_4425",
    x1: 724.431,
    y1: 214.981,
    x2: 726.454,
    y2: 214.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4490_4425",
    x1: 726.454,
    y1: 215.54,
    x2: 800.838,
    y2: 215.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4490_4425",
    x1: 799.72,
    y1: 37.6031,
    x2: 831.111,
    y2: 37.6031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4490_4425",
    x1: 791.164,
    y1: 88.6471,
    x2: 838.669,
    y2: 88.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4490_4425",
    x1: 792.921,
    y1: 116.658,
    x2: 837.086,
    y2: 116.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4490_4425",
    x1: 826.693,
    y1: 171.268,
    x2: 803.287,
    y2: 171.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4490_4425",
    x1: 835.968,
    y1: 96.298,
    x2: 870.392,
    y2: 96.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4490_4425",
    x1: 800.612,
    y1: 27.2912,
    x2: 825.216,
    y2: 26.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4490_4425",
    x1: 800.612,
    y1: 40.3713,
    x2: 825.216,
    y2: 39.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4490_4425",
    x1: 793.879,
    y1: 103.805,
    x2: 829.993,
    y2: 101.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4490_4425",
    x1: 845.15,
    y1: 82.713,
    x2: 864.657,
    y2: 81.7416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4490_4425",
    x1: 848.09,
    y1: 85.9074,
    x2: 849.554,
    y2: 115.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4490_4425",
    x1: 853.919,
    y1: 85.7587,
    x2: 855.276,
    y2: 113.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4490_4425",
    x1: 859.734,
    y1: 85.6413,
    x2: 861.024,
    y2: 111.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4490_4425",
    x1: 865.682,
    y1: 85.5059,
    x2: 866.879,
    y2: 109.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4490_4425",
    x1: 802.661,
    y1: 131.296,
    x2: 821.889,
    y2: 130.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEDEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4490_4425",
    x1: 861.956,
    y1: 105.866,
    x2: 871.071,
    y2: 105.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4490_4425",
    x1: 960.372,
    y1: 229.272,
    x2: 1033.88,
    y2: 229.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4490_4425",
    x1: 979.853,
    y1: 200.464,
    x2: 1025.93,
    y2: 200.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4490_4425",
    x1: 800.173,
    y1: 224.242,
    x2: 961.037,
    y2: 224.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4490_4425",
    x1: 825.881,
    y1: 133.81,
    x2: 870.698,
    y2: 133.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4490_4425",
    x1: 859.241,
    y1: 188.953,
    x2: 871.217,
    y2: 188.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4490_4425",
    x1: 863.659,
    y1: 186.958,
    x2: 884.072,
    y2: 186.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A45825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DFD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4490_4425",
    x1: 801.251,
    y1: 213.588,
    x2: 1208.48,
    y2: 213.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4490_4425",
    x1: -299.385,
    y1: 166.933,
    x2: -298.054,
    y2: 166.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4490_4425",
    x1: 1005.49,
    y1: 125.562,
    x2: 1005.49,
    y2: 118.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4490_4425",
    x1: 932.947,
    y1: 187.971,
    x2: 939.787,
    y2: 187.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4490_4425",
    x1: 943.06,
    y1: 187.97,
    x2: 949.9,
    y2: 187.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4490_4425",
    x1: 1067.14,
    y1: 187.971,
    x2: 1073.98,
    y2: 187.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4490_4425",
    x1: 1077.26,
    y1: 187.971,
    x2: 1084.1,
    y2: 187.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4490_4425",
    x1: 1191.52,
    y1: 187.971,
    x2: 1198.36,
    y2: 187.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4490_4425",
    x1: 1201.64,
    y1: 187.972,
    x2: -298.058,
    y2: 187.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4490_4425",
    x1: 776.939,
    y1: 169.741,
    x2: 783.007,
    y2: 169.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4490_4425",
    x1: 1201.64,
    y1: 351.31,
    x2: 1254.77,
    y2: 351.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4490_4425",
    x1: 1233.17,
    y1: 344.404,
    x2: 1233.17,
    y2: 119.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4490_4425",
    x1: 778.709,
    y1: 169.076,
    x2: 801.251,
    y2: 169.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4490_4425",
    x1: 778.709,
    y1: 124.285,
    x2: 801.251,
    y2: 124.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CABDAD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4490_4425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293.49,
    height: 163.62,
    fill: "white",
    transform: "translate(270.5 137)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyCap);
export default __webpack_public_path__ + "static/media/HyCAP.51b488f6d121001190ee5b78ff3c571d.svg";
export { ForwardRef as ReactComponent };